import {RichText} from '@gongxigames/framework/core/fragments/display';

RichText.setStyle('ErrorPopupButtonTitle', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 60,
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center'
});

RichText.setStyle('ErrorPopupTitle', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 60,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center',
    wordWrap: true,
    wordWrapWidth: 1400,
    textTransform: 'uppercase'
});

RichText.setStyle('ErrorPopupMessage', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 55,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center',
    wordWrap: true,
    wordWrapWidth: 1350
});

RichText.setStyle('SystemPopupTitle', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 60,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center',
    wordWrapWidth: 1350
});

RichText.setStyle('messagePopupContent', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 80,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center',
    wordWrapWidth: 1350
});
